// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteIcon_root__v7j8w"};